/**
 * Redux Store Configuration
 * Centralized state management for the application
 * 
 * ⚠️ IMPORTANT: Per ADR-FE-001, Redux stores data from backend APIs.
 * NO business logic or calculations in Redux slices.
 */

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import brokerAccountsReducer from './slices/brokerAccountsSlice';
import portfolioReducer from './slices/portfolioSlice';
import ordersReducer from './slices/ordersSlice';
import marketDataReducer from './slices/marketDataSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    brokerAccounts: brokerAccountsReducer,
    portfolio: portfolioReducer,
    orders: ordersReducer,
    marketData: marketDataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export selectors
export * from './selectors';

